import {connect} from 'react-redux';

import {CrmSyncIntegrationResourceTypesEnum} from '../../../../../../../src/models/api/crmSyncModel';
import {SyncJobModel} from '../../../../../../../src/models/api/jobModel';
import {makeGetCrmSyncViaResourceType} from '../../../../../../../src/store/data/crmSync/crmSyncsSelectors';
import {
  getHasCrmSyncFullPageSalesforce,
  getHasHubspotContactSync,
  getHasMicrosoftDynamicsAccountSync,
  getHasOutlookDirectorySync,
} from '../../../../../../../src/store/featureFlags/featureFlagsSelectors';
import {navigateToLinkAction} from '../../../../../../../src/store/stateless/navigationActions';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {CrmSyncHeaderDetails} from './crmSyncHeaderDetails';

/*
 * Props.
 */

interface ContactsPageContainerProps {
  activeSyncJobs: ReadonlyArray<SyncJobModel>;
  resourceType: CrmSyncIntegrationResourceTypesEnum;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactsPageContainerProps>()(() => ({
  crmSyncs: makeGetCrmSyncViaResourceType(),
  hasMicrosoftDynamicsAccountSync: getHasMicrosoftDynamicsAccountSync,
  hasCrmSyncFullPageSalesforce: getHasCrmSyncFullPageSalesforce,
  hasHubspotContactSync: getHasHubspotContactSync,
  hasOutlookDirectorySync: getHasOutlookDirectorySync,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  navigateToLink: navigateToLinkAction,
}));

export const CrmSyncHeaderDetailsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CrmSyncHeaderDetails);
